module.exports = __webpack_public_path__ + "img/cju_main1.bd4f4fdd.jpg";